import { Layout } from 'antd';
import styled from 'styled-components';

const HEADER_H = 64;

export const Wrapper = styled(Layout)`
  min-height: 100vh;
  background-color: #dcdcdc;
`;

export const StyledHeader = styled(Layout.Header)`
  display: flex;
  align-items: center;
  gap: 16px;
  height: ${HEADER_H}px;
  padding-inline: 16px;
  box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
  z-index: 1;

  .brand {
    display: flex;
  }

  .ant-menu-horizontal {
    flex: 1;
    line-height: ${HEADER_H}px;
    width: 46px;
    border-bottom: none;

    > .ant-menu-item {
      display: flex;
      align-items: center;
      padding-inline: 10px;
      .ant-menu-title-content {
        margin-left: 5px;
      }
      &:after {
        inset-inline: 10px;
      }
    }
  }
`;
